import { useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { Link, useHistory } from "react-router-dom"
import classnames from 'classnames'

import { Spinner, SpinnerSize, Nav, DefaultButton, IconButton } from "@fluentui/react"
import Notifications from "./Notifications"

import './AppLayout.scss'
import { selectUserIsAdmin, selectUserIsLoading } from "selectors/user"
import { signOut } from "actions/user"


const adminLinks = [
  {
    links: [
      {
        name: 'Match List',
        key: 'dashboard',
        url: '/dashboard',
      },
      {
        name: 'Elo',
        key: 'elo',
        url: '/elo',
      },
      {
        name: 'Glicko',
        key: 'glicko',
        url: '/glicko',
      },
      {
        name: 'History',
        key: 'history',
        url: '/history',
      },
      {
        name: 'Compare',
        key: 'compare',
        url: '/compare',
      },
      {
        name: 'Player',
        key: 'player',
        url: '/player',
      },
      {
        name: 'Tournament',
        key: 'tournament',
        url: '/tournament',
      },
      {
        name: 'Statistics',
        key: 'statistics',
        url: '/statistics',
      },
      {
        name: "Add Match",
        key: "add",
        url: "/add",
      },
      {
        name: "FAQ",
        key: "faq",
        url: "/faq",
      },
    ]
  }
]

const MainNav = ({ isOpen, onClose }) => {
  const history = useHistory()
  const handleNavClick = (ev, element) => {
    ev.preventDefault()
    history.push(element.url)
    onClose()
  }

  return (
    <>
      {isOpen && <div className="navOverlay" onClick={onClose} />}
      <div className={classnames("navBar", { navOpen: isOpen })}>
        <Nav groups={adminLinks} onLinkClick={handleNavClick} />
        <div className="navBarFooter">
          <div>
            Questions?<br/>
            Msg Fireworks on Discord
          </div>
        </div>
      </div>
    </>
  )
}

const AppLayout = ({ children }) => {
  const history = useHistory()
  const dispatch = useDispatch()
  const loading = useSelector(selectUserIsLoading)
  const isAdmin = useSelector(selectUserIsAdmin)
  const [navOpen, setNavOpen] = useState(false)

  const handleSignOut = () => {
    dispatch(signOut())
    history.push('/login')
  }

  return (
    <>
      <header className="header">
        <div className="headerLeft">
          <IconButton
            className="menuButton"
            iconProps={{ iconName: 'GlobalNavButton' }}
            onClick={() => setNavOpen(prev => !prev)}
          />
          <Link to="/">
            <img src="/logo.png" alt="logo" />
          </Link>
        </div>
        { isAdmin ? <DefaultButton className="signOutButton" onClick={handleSignOut}>
                      Sign Out
                    </DefaultButton> : null
        }
      </header>
      <MainNav isOpen={navOpen} onClose={() => setNavOpen(false)} />
      <div className={classnames("content", { navPresent: true })}>
        { loading ? <Spinner size={SpinnerSize.large} /> : children }
      </div>
      <Notifications />
    </>
  )
}

export default AppLayout
